module.exports = __webpack_public_path__ + "static/media/report-research-design-1.c38c08f4.png";